import React, { useContext } from 'react'
import Part from './Parts'
import { PartsContext } from './App'

export default function PartsList({ parts }) {
  const { handlePartAdd } = useContext(PartsContext)
  return (
    <div className="parts-list">
      <div>
        { parts.map(part => {
          return (
            <Part key={ part.id } { ...part } />
          )
        })}
      </div>
      <div className="parts-list__add-part-btn-container">
        <button 
          className="btn btn--primary"
          onClick={handlePartAdd}
        >
          Add Part
        </button>
      </div>
    </div>
  )
}